import searchModel from '../data/searchModel';
import { OptionWithPath } from 'owa-options-store';

export default function filterOptions(query: string): OptionWithPath[] {
    return searchModel()
        .search(query)
        .map(result => result.option);
}
